module.exports = "/assets/756d3562f9ce1ba5958a99a797487522.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/atc/atc-flights-view/flight-recommendation/flight-segment/flight-segment-details-flight/assets/icon-take-off.png
// module id = 3659
// module chunks = 0